import { LOADER_STATUS, TABLE_DATA, TOTAL_PAGES, SET_ENTITY_LIST, SET_SELECTED_ENTITY } from "./constants";

export const initialState = {
  loaderStatus: false,
  tableData: [],
  totalPages: 1,
  entityList: [],
  selectedEntity: "",
};

/* eslint-disable default-case, no-param-reassign */
const imsRecoUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case TABLE_DATA:
      return {
        ...state,
        tableData: action.tableData,
      };
    case TOTAL_PAGES:
      return {
        ...state,
        totalPages: action.totalPages,
      };
    case SET_ENTITY_LIST:
      return {
        ...state,
        entityList: action.payload,
      };
    case SET_SELECTED_ENTITY:
      return {
        ...state,
        selectedEntity: action.payload,
      };
    default:
      return state;
  }
};

export default imsRecoUploadReducer;
